import api from "../http/api";

export const educationInstitution = async ({
  institutionId,
  startDate,
  endDate,
  knowledgeArea,
  discipline,
  courseTypeId,
  courseGradeId,
  localityId,
  filtermodality
}) => {
  const queryParams = new URLSearchParams();
  console.log('knowledgeArea', knowledgeArea)

  if (knowledgeArea !== undefined && knowledgeArea !== null) {
    queryParams.append('knowledgeArea', knowledgeArea);
  }

  if (discipline !== undefined && discipline !== null) {
    queryParams.append('discipline', discipline);
  }

  if (courseTypeId !== undefined && courseTypeId !== null) {
    queryParams.append('courseType', courseTypeId);
  }

  if (courseGradeId !== undefined && courseGradeId !== null) {
    queryParams.append('courseGrade', courseGradeId);
  }

  if (localityId !== undefined && localityId !== null) {
    queryParams.append('locality', localityId);
  }

  if (filtermodality !== undefined && filtermodality !== null) {
    queryParams.append('modality', filtermodality);
  }

  const query = `${startDate ? `?startDate=${startDate}` : ""}${endDate ? `&endDate=${endDate}&` : ""
    }`;

  try {
    const response = await api.client.get(
      `api/v1/educationInstitution${query}${queryParams.toString()}`, {
      headers: {
        institutionId: institutionId
      }
    }
    );

    return response.data;
  } catch (error) {
    throw new Error("Falha na conexão com a API de login");
  }
};

export const educationConsolidatedData = async ({
  institutionId,
  page = 1,
  pageSize = 30,
  searchTerm = "",
  filters = [],
  joins = null,
  startDate = null,
  endDate = null,
  fileId = null
}) => {
  const body = {
    page,
    pageSize
  };

  if (searchTerm) {
    body.searchTerm = searchTerm;
  }

  // Filtro por arquivo de origem (vem da URL). Restringe às linhas daquele arquivo no backend,
  // sem virar um filtro visível na tela.
  if (fileId) {
    body.fileId = fileId;
  }

  if (startDate) {
    body.startDate = startDate;
  }

  if (endDate) {
    body.endDate = endDate;
  }

  // Adicionar filtros
  if (filters && filters.length > 0) {
    // Agrupar filtros por groupId
    const groupedFilters = {};
    filters.forEach((filter) => {
      const groupId = filter.groupId !== undefined ? filter.groupId : 0;
      if (!groupedFilters[groupId]) {
        groupedFilters[groupId] = [];
      }
      groupedFilters[groupId].push(filter);
    });

    // Criar filterGroups
    const filterGroups = Object.values(groupedFilters).map((group) => {
      return {
        condition: "AND",
        filters: group.map((filter) => ({
          field: filter.field,
          operator: filter.operator === "eq" ? "=" : filter.operator,
          values: filter.values
        }))
      };
    });

    // OR entre grupos (a UI cria um novo grupo a cada condição "OU"); AND quando há um só grupo.
    body.groupCondition = Object.keys(groupedFilters).length > 1 ? "OR" : "AND";
    body.filterGroups = filterGroups;
  }

  // Adicionar joins
  if (joins && joins.length > 0) {
    body.joins = joins;
  }

  try {
    const response = await api.client.post(
      'api/v1/EducationInstitution/ConsolidatedData',
      body,
      {
        headers: {
          institutionId: institutionId
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar dados consolidados acadêmicos:", error);
    throw new Error("Falha ao buscar dados consolidados acadêmicos");
  }
};

export const getSavedEducationFilterById = async ({ institutionId, filterId }) => {
  try {
    const response = await api.client.get(
      `api/v1/SavedFilter/${filterId}`,
      {
        headers: {
          institutionId: institutionId
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar filtro salvo:", error);
    throw new Error("Falha ao buscar filtro salvo");
  }
};

export const classConsolidatedData = async ({
  institutionId,
  page = 1,
  pageSize = 30,
  searchTerm = ""
}) => {
  const queryParams = new URLSearchParams();
  
  queryParams.append('page', page);
  queryParams.append('pageSize', pageSize);
  
  if (searchTerm) {
    queryParams.append('searchTerm', searchTerm);
  }

  try {
    const response = await api.client.get(
      `api/v1/ClassInstitution/ConsolidatedData?${queryParams.toString()}`,
      {
        headers: {
          institutionId: institutionId
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar dados consolidados de turma:", error);
    throw new Error("Falha ao buscar dados consolidados de turma");
  }
};

export const adhesionConsolidatedData = async ({
  institutionId,
  page = 1,
  pageSize = 30,
  searchTerm = "",
  startDate = null,
  endDate = null
}) => {
  const queryParams = new URLSearchParams();
  
  if (startDate) {
    queryParams.append('startDate', startDate);
  }
  
  if (endDate) {
    queryParams.append('endDate', endDate);
  }
  
  queryParams.append('page', page);
  queryParams.append('pageSize', pageSize);
  
  if (searchTerm) {
    queryParams.append('searchTerm', searchTerm);
  }

  try {
    const response = await api.client.get(
      `api/v1/AdhesionInstitution/ConsolidatedData?${queryParams.toString()}`,
      {
        headers: {
          institutionId: institutionId
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar dados consolidados de adesão:", error);
    throw new Error("Falha ao buscar dados consolidados de adesão");
  }
};

export const teacherConsolidatedData = async ({
  institutionId,
  page = 1,
  pageSize = 30,
  searchTerm = "",
  filters = [],
  joins = null
}) => {
  const body = { page, pageSize };

  if (searchTerm) body.searchTerm = searchTerm;

  if (filters && filters.length > 0) {
    const groupedFilters = {};
    filters.forEach((filter) => {
      const groupId = filter.groupId !== undefined ? filter.groupId : 0;
      if (!groupedFilters[groupId]) groupedFilters[groupId] = [];
      groupedFilters[groupId].push(filter);
    });

    const filterGroups = Object.values(groupedFilters).map((group) => ({
      condition: "AND",
      filters: group.map((filter) => ({
        field: filter.field,
        operator: filter.operator === "eq" ? "=" : filter.operator,
        values: filter.values
      }))
    }));

    body.groupCondition = "AND";
    body.filterGroups = filterGroups;
  }

  if (joins && joins.length > 0) body.joins = joins;

  try {
    const response = await api.client.post(
      'api/v1/TeacherInstitution/ConsolidatedData',
      body,
      { headers: { institutionId } }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar dados consolidados de docentes:", error);
    throw new Error("Falha ao buscar dados consolidados de docentes");
  }
};

export const getSavedTeacherFilterById = async ({ institutionId, filterId }) => {
  try {
    const response = await api.client.get(
      `api/v1/SavedFilter/${filterId}`,
      { headers: { institutionId } }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar filtro salvo:", error);
    throw new Error("Falha ao buscar filtro salvo");
  }
};